"use client";

import styles from "@/styles/modules/components/meetings-and-events/moduleRooms.module.scss";
import { MeetingsAndEventsRoom } from "@/types/wordpress";
import ModuleRoomsRoom from "./ModuleRoomsRoom";
import { useState } from "react";

interface ModuleRoomsProps {
  rooms: MeetingsAndEventsRoom[];
}

export default function ModuleRooms({ rooms }: ModuleRoomsProps) {
  const [openedRoom, setOpenedRoom] = useState<number | null>(0);

  if (!rooms) return null;

  return (
    <section className={styles.moduleRooms}>
      <div className={styles.moduleRoomsContainer} data-aos="fadeIn">
        {rooms.map((room, i) => (
          <ModuleRoomsRoom
            key={i}
            room={room}
            opened={(openedRoom === i) ? true : false}
            setOpened={setOpenedRoom}
            id={i}
          />
        ))}
      </div>
    </section>
  );
}
